export const SIGN = '/'
export const MDM_DEALS = '/deals'
export const SELECT_PLAN = '/select-plan'
export const STATIC_SEND_PARTNER_DATA = '/send-partner-data'
export const CONTACT_US = '/contact-us'
